import React, { useState, useEffect } from "react";
import religionOptions from "./data/religionOptions.json";
import SuccessModal from "./SuccessModal";
import { useOutletContext } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import config from "../../../config/config";
import axios from "axios";

const ReligionComponent = ({ user }) => {
  const [religions, setReligions] = useState(
    religionOptions.religions.map((religion) => ({
      text: religion,
      isSelected: false,
    }))
  );
  const [validationError, setValidationError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const { isSmallScreen, handleBackClick } = useOutletContext();
  const baseURL = config.API_BASE_URL;

  useEffect(() => {
    if (user && user.id) {
      const fetchReligionData = async () => {
        try {
          const response = await axios.get(
            `${baseURL}/v1/worker-users/${user.id}`
          );
          const fetchedUserData = response.data;
          const userReligions = fetchedUserData.religion;

          const updatedReligions = religions.map((religion) => ({
            text: religion.text,
            isSelected: userReligions.includes(religion.text),
          }));

          setReligions(updatedReligions);
        } catch (error) {
          console.error("Failed to fetch religion data:", error);
        }
      };

      fetchReligionData();
    }
  }, [user, baseURL]);

  const toggleReligionSelection = (index) => {
    const newReligions = [...religions];
    newReligions[index].isSelected = !newReligions[index].isSelected;

    console.log(
      `Religion: ${newReligions[index].text} ${
        newReligions[index].isSelected ? "Selected" : "Deselected"
      }`
    );

    setReligions(newReligions);
    setValidationError("");
  };

  const handleSave = async () => {
    setValidationError("");

    const isAnyReligionSelected = religions.some(
      (religion) => religion.isSelected
    );

    if (!isAnyReligionSelected) {
      setValidationError("Please select at least one religion.");
      return;
    }

    const selectedReligions = religions
      .filter((religion) => religion.isSelected)
      .map((religion) => religion.text);

    const religionData = {
      religion: selectedReligions,
    };
    console.log("Selected religions for patching:", selectedReligions);
    try {
      const response = await axios.patch(
        `${baseURL}/v1/worker-users/${user.id}`,
        religionData
      );

      if (response.data) {
        setShowModal(true);
      }
    } catch (error) {
      console.error("Failed to update religion data", error);
      setValidationError("Failed to update. Please try again.");
    }
  };

  return (
    <div className="religion-custom-component-container">
      {showModal && <SuccessModal />}
      <div className="religion-indicative-above-div">
      <div className="profile-back-container">
        {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaAngleLeft className="profile-back-icon"/> 
            </div>
          )}
          <h2>Religion</h2>
        </div>
        
        <p>
          Select your religion, this will help clients search for Support
          Workers who share their religion.
        </p>
      </div>

      <div className="religion-buttons-container">
        {religions.map((religion, index) => (
          <button
            key={religion.text}
            className={`religion-horizontal-button ${
              religion.isSelected ? "selected" : ""
            }`}
            onClick={() => toggleReligionSelection(index)}
          >
            <div className="button-checkmark">
              {religion.isSelected ? "✓" : ""}
            </div>
            <div className="button-text">{religion.text}</div>
          </button>
        ))}
      </div>
      {validationError && (
        <div className="religion-error">{validationError}</div>
      )}
      <div className="religion-save">
        <button onClick={handleSave}>Save and continue</button>
      </div>
    </div>
  );
};

export default ReligionComponent;
